<template>
  <div>
    <label v-if="label" :for="name">{{ label }}</label>
    <select
      @change="onChange"
      :value="selected"
      :class="{ 'form-control-sm': size === 'small' }"
      :name="name"
      :disabled="disabled"
      class="form-control custom-select"
    >
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <template v-for="(group, i) in options">
        <optgroup
          v-if="optgroups()"
          :label="group.label"
          :key="`optgroup-${group.value}-${group.label}-${i}`"
        >
          <option
            v-for="(option, j) in group.value"
            :key="j"
            :value="option.value"
            :disabled="disabledOptions.includes(option.value)"
          >
            {{ option.label }}
          </option>
        </optgroup>
        <option
          v-else
          :value="group.value"
          :key="`option-${group.value}-${group.label}-${i}`"
          :disabled="disabledOptions.includes(group.value)"
        >
          {{ group.label }}
        </option>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  props: {
    options: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledOptions: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: "default",
      validator: value => ["default", "small"].includes(value),
    },
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selected: this.active,
    };
  },
  methods: {
    onChange(e) {
      this.selected = e.target.value;
      this.$emit("change", this.selected);
    },
    optgroups() {
      return typeof this.options[0].value == "object";
    },
  },
};
</script>
